import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { FormsScreen } from "#app/components/forms/forms-screen";
import { withFeatureFlag, withPermission } from "#app/components/permissions/require-permission";
import { FeatureFlagKey } from "#app/hooks/use-feature-flags";
import { useFormBuilderDialogActions } from "#app/lib/form-builder-dialog-context";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";

/** An id with no form behind it opens on the dialog's "Form not found" state. */
function FormBuilderDeepLink() {
  const { formId } = Route.useParams();
  const { openFormBuilder } = useFormBuilderDialogActions();
  const { replace } = useAppNavigate();

  useEffect(() => {
    openFormBuilder(formId, { onClose: () => replace("/settings/forms") });
  }, [formId, openFormBuilder, replace]);

  return <FormsScreen />;
}

export const Route = createFileRoute("/(app)/$workspace/settings/forms/$formId")({
  component: withPermission("forms.manage", withFeatureFlag(FeatureFlagKey.FORMS, FormBuilderDeepLink)),
});
